import { useEffect, useRef, useState } from "react";
import { logger } from "../../lib/logger";
import { Button } from "../ui/button";

const COPIED_LABEL_DURATION_MS = 2000;

interface CopyZoomJoinUrlButtonProps {
  zoomMeetingUrl: string;
}

export function CopyZoomJoinUrlButton({
  zoomMeetingUrl,
}: CopyZoomJoinUrlButtonProps) {
  const [copied, setCopied] = useState(false);
  const resetTimerRef = useRef<number | null>(null);

  // 一覧は再取得で行が作り直されるため、消えた行のタイマーを残さない
  useEffect(
    () => () => {
      if (resetTimerRef.current !== null) {
        window.clearTimeout(resetTimerRef.current);
      }
    },
    [],
  );

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(zoomMeetingUrl);
    } catch (caught) {
      logger.error(caught as Error);
      alert("コピーに失敗しました");
      return;
    }

    setCopied(true);
    if (resetTimerRef.current !== null) {
      window.clearTimeout(resetTimerRef.current);
    }
    resetTimerRef.current = window.setTimeout(
      () => setCopied(false),
      COPIED_LABEL_DURATION_MS,
    );
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleCopy}
      className="text-[var(--color-text-secondary)] text-xs"
    >
      {copied ? "コピーしました" : "参加URLをコピー"}
    </Button>
  );
}
